module.exports = __webpack_public_path__ + "static/media/IG.5f8cca97.png";